<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app'
};
</script>

<style>
body,html{
    padding: 0;
    margin: 0;
    height: 100%;
    width: 100%;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    width: 100%;
    font-size: 14px;
    background-image:-webkit-gradient(linear, left top, left bottom, color-stop(0%,#f7f8fa), color-stop(90%,#e3e8f2));
}
</style>



// WEBPACK FOOTER //
// App.vue?fd2263b4